<template>
  <main class="payment-transfer-page  payment-page  container">
    <div class="payment-transfer-page__content  payment-page__content  container-inner">
      <h1 class="payment-page__title">{{ $tPayment('Jobian Pay ― вигідні перекази') }}</h1>
      <div class="payment-transfer-page__main  payment-page__main">

        <div class="payment-transfer-page__cards-group">
          <div class="payment-transfer-page__cards-group-title">З рахунку:</div>
          <PaymentAccountCardCarousel @change="onFromChange"
                                      class="payment-transfer-page__cards-group-carousel"/>
        </div>

        <div class="payment-transfer-page__cards-group">
          <div class="payment-transfer-page__cards-group-title">На рахунок:</div>
          <PaymentAccountCardCarousel @change="onFromChange"
                                      class="payment-transfer-page__cards-group-carousel"/>
        </div>

        <div class="payment-transfer-page__input-section">
          <div class="payment-transfer-page__input-title">Сума:</div>
          <label class="payment-transfer-page__input-wrap">
            <input type="text"
                   :value="'500,00'"
                   class="payment-transfer-page__input">
            <span class="payment-transfer-page__input-mark-text">EUR</span>
          </label>
        </div>
        <button class="payment-transfer-page__btn  base-btn  base-btn--green">
          <span>Переказати</span>
          <BaseSvg name="ico-arrow-light"
                   style="margin-left: 0.5rem"
                   width="0.5rem"
                   height="0.8rem"/>
        </button>

        <div class="payment-transfer-page__make-regular-wrap">
          <BaseCheckbox label="Зробити платіж регулярним"
                        class="payment-transfer-page__make-regular"/>
        </div>

        <PaymentAccountRecurringPayments class="payment-transfer-page__recurring-payments"/>
        <PaymentAccountHistory class="payment-transfer-page__history"/>
      </div>
    </div>
  </main>
</template>

<script>
  import PaymentAccountCardCarousel from '@/components/payment/PaymentAccountCardCarousel'
  import PaymentAccountRecurringPayments from '@/components/payment/PaymentAccountRecurringPayments'
  import PaymentAccountHistory from '@/components/payment/PaymentAccountHistory'

  export default {
    name: 'PaymentTransferPage',
    components: {
      PaymentAccountCardCarousel,
      PaymentAccountRecurringPayments,
      PaymentAccountHistory,
    },
    data() {
      return {}
    },
    methods: {
      onFromChange(value) {
        console.log(value)
      },
      onToChange(value) {
        console.log(value)
      }
    }
  }
</script>

<style lang="less">

</style>
